import React from 'react';

import {
    Typography
} from '@material-ui/core';

import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn'

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: 150,
        padding: theme.spacing(3),
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column'
    },
    image: {
        display: 'inline-block',
        marginTop: 50,
        width: '200px',
        height: '200px'
    }
}));

export const BookedPage = (props) => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Typography align="center" variant="h2">
                Prenotazione già effettuata
            </Typography>
            <br />
            <Typography align="center" variant="body1">
                La tua prenotazione è stata registrata e confermata. Non puoi eseguire altre prenotazioni.
            </Typography>
            <br />
            <AssignmentTurnedInIcon className={classes.image} />
        </div>
    );
}